import
{
	RifleAim,
	CharacterStateBase,
	EndWalk,
	Idle,
	JumpRunning,
    Punch,
	Sprint,
} from './_stateLibrary';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import { WalkAudio } from './audio/WalkAudio';

export class Walk extends CharacterStateBase
{
	private audio: WalkAudio | null = null;

	constructor(character: Character)
	{
		super(character);
		this.canEnterVehicles = true;
		this.character.simulation.setArcadeVelocityTarget(0.5);
		this.playAnimation(CharacterAnimation.Walk, 0.1);

		if (character.world?.audioManager) {
			this.audio = new WalkAudio(character.world.audioManager, character);
			this.audio.play();
		}
	}

	public exit(): void
	{
		this.audio?.stop();
	}

	public update(timeStep: number): void
	{
		super.update(timeStep);
		this.character.setCameraRelativeOrientationTarget();

		this.fallInAir();
        this.onDie();
	}

	public onInputChange(): void
	{
		super.onInputChange();

		if (this.noDirection())
		{
			this.character.setState(new EndWalk(this.character));
		}

        if (this.character.actions.punch.isPressed) {
            this.character.setState(new Punch(this.character));
        }

		if (this.character.actions.run.isPressed)
		{
			this.character.setState(new Sprint(this.character));
		}

		if (this.character.actions.run.justPressed)
		{
			this.character.setState(new Sprint(this.character));
		}

		if (this.character.actions.jump.justPressed)
		{
			this.character.setState(new JumpRunning(this.character));
		}

		if (this.noDirection())
		{
			if (this.character.simulation.velocity.length() > 1)
			{
				this.character.setState(new EndWalk(this.character));
			}
			else
			{
				this.character.setState(new Idle(this.character));
			}
		}
	}
}
